import { FCX } from "@datassential/platform-ui-lib";

interface HeaderCellProps {
    title: string;
    subtitle: string;
}

const HeaderCell: FCX<HeaderCellProps> = ({ title, subtitle }) => (
    <div className="HomePlacesGrowingChains__header-cell">
        <span>{title}</span>
        <span className="HomePlacesGrowingChains__header-subtitle">{subtitle}</span>
    </div>
);

export default HeaderCell;